const WEEKDAYS_ID = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'];
const MONTHS_ID = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember',
];

function parse(d: string | number | Date): Date {
  if (d instanceof Date) return d;
  return new Date(d);
}

export function formatDate(d: string | number | Date, opts?: Intl.DateTimeFormatOptions): string {
  const date = parse(d);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(
    'id-ID',
    opts ?? { day: 'numeric', month: 'long', year: 'numeric' },
  ).format(date);
}

export function formatDateShort(d: string | number | Date): string {
  const date = parse(d);
  if (Number.isNaN(date.getTime())) return '—';
  return `${date.getDate()} ${MONTHS_ID[date.getMonth()]} ${date.getFullYear()}`;
}

export function formatTime(d: string | number | Date): string {
  const date = parse(d);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('id-ID', { hour: '2-digit', minute: '2-digit' }).format(date);
}

export function formatDateTime(d: string | number | Date): string {
  const date = parse(d);
  if (Number.isNaN(date.getTime())) return '—';
  return `${WEEKDAYS_ID[date.getDay()]}, ${date.getDate()} ${MONTHS_ID[date.getMonth()]} ${date.getFullYear()} · ${formatTime(date)}`;
}

export function formatRelative(d: string | number | Date): string {
  const date = parse(d);
  const diff = Date.now() - date.getTime();
  const mins = Math.round(diff / 60_000);
  if (Number.isNaN(date.getTime())) return '—';
  if (mins < 1) return 'baru saja';
  if (mins < 60) return `${mins} mnt lalu`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} jam lalu`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days} hari lalu`;
  return formatDateShort(date);
}

export function initials(name?: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function formatNilai(n?: number): string {
  if (n === undefined || Number.isNaN(n)) return '—';
  return n.toFixed(2);
}

/** Compose a display name with academic titles, e.g. "Dr. Nurhasanah, M.Pd.". */
export function withGelar(name?: string, gelarDepan?: string, gelarBelakang?: string): string {
  const base = (name ?? '').trim();
  if (!base) return '';
  return `${gelarDepan?.trim() ? `${gelarDepan.trim()} ` : ''}${base}${gelarBelakang?.trim() ? `, ${gelarBelakang.trim()}` : ''}`;
}

export function utcNowIso(): string {
  return new Date().toISOString();
}

/**
 * Allow-list for stored document URLs rendered as navigable links
 * (berkas downloads, consult attachments). http(s) plus image/pdf data
 * URIs only — blocks javascript:/data:text/html schemes that could
 * execute when opened. Markdown links are validated separately (regex).
 */
export function isSafeDocUrl(url: string): boolean {
  return /^(https?:\/\/|data:image\/|data:application\/pdf)/.test(url);
}
